import { useCallback } from 'react';
import kioskSessionService from 'services/kiosk-session-service';
import { useAppDispatch } from 'store';
import { setKioskSessionAction, setKioskStatusAction } from 'store/actions/kiosk-session-actions';
import { KioskStatus } from 'types/kiosk/KioskStatus';

/** Clears the persisted kiosk session and drops the gate to INACTIVE (router falls back to activation).
 *  Shared by the start-registration hook and the clock-in modal for 401/dead-session handling. */
export const useEndKioskSession = () => {
  const dispatch = useAppDispatch();
  return useCallback(() => {
    kioskSessionService.clear();
    dispatch(setKioskSessionAction(null));
    dispatch(setKioskStatusAction(KioskStatus.INACTIVE));
  }, [dispatch]);
};
